import React from "react";
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";

function ModalEdit({
  args,
  isOpen,
  toggle,
  close,
  onChange,
  onKeyUp,
  onClick,
  dataBrand,
  dataCategory,
  dataEdit,
  error,
}) {
  return (
    <Modal isOpen={isOpen} toggle={toggle} {...args}>
      <ModalHeader toggle={toggle} close={close}>
        <span className="t-primary fs-4 fw-bold">Edit</span>
      </ModalHeader>
      <ModalBody className="px-4">
        <div className="w-100 mt-3">
          <div>
            <label className="mb-2">Name</label>
            <input
              className="fs-6 border_input rounded w-100"
              type="text"
              name="name"
              onChange={onChange}
              onKeyUp={onKeyUp}
              defaultValue={dataEdit.name}
            />
          </div>

          {error.name && <p className="error">{error.name}</p>}
        </div>

        <div className="w-100 mt-3">
          <div>
            <label className="mb-2">Image</label>
            <input
              name="files"
              id="files"
              onChange={onChange}
              className="fs-6 border_input rounded w-100"
              type="file"
            />
          </div>

          {error.image && <p className="error">{error.image}</p>}
        </div>

        <div className="w-100 d-flex mt-3">
          <div className="w-50 me-2">
            <label className="mb-2">Category</label>
            <select
              className="fs-6 border_input rounded w-100"
              onClick={onChange}
              defaultValue={dataEdit.categoryId}
              name="categoryId"
            >
              {dataCategory?.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.name}
                </option>
              ))}
            </select>
          </div>

          <div className="w-50 ms-2">
            <label className="mb-2">Brand</label>
            <select
              className="fs-6 border_input rounded w-100"
              onClick={onChange}
              defaultValue={dataEdit.brandId}
              name="brandId"
            >
              {dataBrand?.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.name}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="d-flex mt-3">
          <div className="w-60 me-2">
            <div>
              <label className="mb-2">Price</label>
              <input
                className="fs-6 border_input rounded w-100"
                type="number"
                min={0}
                name="price"
                defaultValue={dataEdit.price}
                onChange={onChange}
              />
            </div>
          </div>

          <div className="w-40">
            <div>
              <label className="mb-2">Discount</label>
              <input
                className="fs-6 border_input rounded w-100"
                type="number"
                min={0}
                name="discount"
                defaultValue={dataEdit.discount}
                onChange={onChange}
              />
            </div>
          </div>
        </div>

        <div className="w-100 mt-3">
          <div>
            <label className="mb-2">Dimension</label>
            <input
              className="fs-6 border_input rounded w-100"
              type="number"
              min={0}
              name="dimension"
              defaultValue={dataEdit.dimension}
              onChange={onChange}
            />
          </div>
        </div>

        <div className="w-100 mt-3">
          <div>
            <label className="mb-2">Quantity</label>
            <input
              className="fs-6 border_input rounded w-100"
              type="number"
              min={0}
              name="quantity"
              defaultValue={dataEdit.quantity}
              onChange={onChange}
            />
          </div>
        </div>

        <div className="w-100 mt-3">
          <div>
            <label className="mb-2">Description</label>
            <input
              className="fs-6 border_input rounded w-100"
              type="text"
              name="description"
              onChange={onChange}
              defaultValue={dataEdit.description}
            />
          </div>
        </div>

        <div className="d-flex justify-content-center mt-4">
          <Button
            className="btn_add w-50"
            data-id={dataEdit.id}
            onClick={onClick}
          >
            Save
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
}

export default ModalEdit;
